<template>
  <div class="card card-rounded card-shadow border-0 icon-watermark-top fade-in-up animation-delay card-with-watermark"
       style="--delay-index: 1;">
    <div class="card-body">
      <h1 class="h5 mb-3">{{ title }}</h1>

      <QuestionRadio v-if="radioQuestion" :question="radioQuestion" :value.sync="radioValue" :invalid="invalid"/>
      <QuestionTextArea v-if="textQuestion" :question="textQuestion" :value.sync="textValue"/>

      <button class="btn btn-lg btn-primary btn-block text-white mt-4"
              :class="{'disabled pe-auto btn-opacity-65': !radioValue}" @click="submit">{{ $t('SurveyPage.submit') }}
      </button>
      <div id="button-skip-survey" class="btn btn-lg btn-block mb-n2" @click="$emit('on-survey-skipped')">
        {{ $t('SurveyPage.skip') }}
      </div>
    </div>

    <Icon icon-name="iute-pepper-outline" icon-class="icon-watermark"></Icon>
  </div>
</template>
<style>
.btn-opacity-65 {
  opacity: 0.65 !important;
}

.pe-auto {
  pointer-events: auto !important;
}
</style>
<script>
import Icon from '@shared/components/Icon'
import QuestionRadio from '@shared/components/survey/QuestionRadio'
import QuestionTextArea from '@shared/components/survey/QuestionTextArea'

export default {
  name: 'QuestionGroup',
  components: { Icon, QuestionRadio, QuestionTextArea },
  props: ['questions', 'title'],
  data() {
    return {
      radioQuestion: this.questions.find(q => q.type === 'RANGE'),
      textQuestion: this.questions.find(q => q.type === 'TEXTAREA'),
      radioValue: undefined,
      textValue: undefined,
      invalid: false
    }
  },
  methods: {
    submit() {
      this.invalid = !this.radioValue
      if (!this.invalid) {
        this.$emit('submit', [
          { id: this.radioQuestion.id, value: this.radioValue || '' },
          { id: this.textQuestion.id, value: this.textValue || '' }
        ])
      }
    }
  }
}
</script>
